import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { login } from "../../../auth/auth";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const fetchVideosFromAPI = async (configId, passphrase, authToken) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/api/expression/config_id/${configId}/passphrase/${passphrase}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    if (response.data.status === "OK") {
      return response.data.data;
    } else {
      throw new Error("Failed to fetch video data");
    }
  } catch (error) {
    console.error("Error fetching video data:", error);
  }
};

const mergeVideos = async (videos) => {
  const ffmpeg = createFFmpeg({
    log: true,
    worker: true,
  });

  await ffmpeg.load();

  for (let i = 0; i < videos.length; i++) {
    const videoUrl = videos[i];
    console.log("Video URL:", videoUrl);

    const videoFile = await fetchFile(videoUrl);
    ffmpeg.FS("writeFile", `input${i}.mp4`, videoFile);
  }

  const outputFileName = "output.mp4";
  await ffmpeg.run(
    "-i",
    `concat:input0.mp4|input1.mp4|input2.mp4`,
    "-c",
    "copy",
    outputFileName
  );

  const data = ffmpeg.FS("readFile", outputFileName);
  const videoBlob = new Blob([data.buffer], { type: "video/mp4" });
  const videoUrl = URL.createObjectURL(videoBlob);

  console.log("Merged video URL:", videoUrl);

  return videoUrl;
};

const VideoTest = () => {
  const [authToken, setAuthToken] = useState("");
  const [videoMode, setVideoMode] = useState("idle");
  const [videoSrc, setVideoSrc] = useState("");
  const videoRef = useRef(null);

  const configId = "1";
  const passphrase = "$2b$12$q6Nvi.FWjg8JzS1PIPMEKe";

  useEffect(() => {
    const performLogin = async () => {
      try {
        const token = await login();
        setAuthToken(token);
      } catch (error) {
        console.error("Failed to login:", error);
      }
    };

    performLogin();
  }, []);

  useEffect(() => {
    if (authToken) {
      const fetchData = async () => {
        try {
          const videoData = await fetchVideosFromAPI(
            configId,
            passphrase,
            authToken
          );
          const videos = [
            videoData.idleHyperlink,
            videoData.talkHyperlink,
            videoData.angryHyperlink,
            videoData.happyHyperlink,
          ];

          console.log("Video URLs to merge:", videos);

          const mergedVideo = await mergeVideos(videos);

          if (mergedVideo) {
            setVideoSrc(mergedVideo);
          } else {
            console.error("Merged video is invalid or empty");
          }
        } catch (error) {
          console.error("Error fetching or merging videos:", error);
        }
      };

      fetchData();
    }
  }, [authToken]);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement && videoSrc) {
      switch (videoMode) {
        case "angry":
          videoElement.currentTime = 5;
          break;
        case "happy":
          videoElement.currentTime = 10;
          break;
        case "neutral":
          videoElement.currentTime = 2;
          break;
        default:
          videoElement.currentTime = 0;
          break;
      }

      videoElement.play();
    }
  }, [videoMode, videoSrc]);

  return (
    <div className="video-test">
      <video
        ref={videoRef}
        className="avatar_video--no-chromakey"
        src={videoSrc}
        autoPlay
        muted
        onError={(e) => console.error("Video error:", e)}
      />
      <div className="btn-container">
        <button className="angry-btn" onClick={() => setVideoMode("angry")}>
          Angry
        </button>
        <button className="happy-btn" onClick={() => setVideoMode("happy")}>
          Happy
        </button>
        <button className="neutral-btn" onClick={() => setVideoMode("neutral")}>
          Neutral
        </button>
        <button className="idle-btn" onClick={() => setVideoMode("idle")}>
          Idle
        </button>
      </div>
    </div>
  );
};

export default VideoTest;
